import React from "react";
import { useForm } from "react-hook-form";
import { CancelButton, FormButton } from "../../../../../components/Button";
import Loader from "../../../../../components/Loader";
import { FormFieldset, Input } from "../../../../../components/Form";
import { ITaskSheetId, IAddTaskSheet } from "../../Tasksheet.props";
import useEditTaskSheet from "./useEditTasksheet";
import CustomDropdown from "../../../../../components/DropDown";
import { priority, status } from "../../__Test__/MockTasksheet";

const EditTaskSheet: React.FC<ITaskSheetId> = ({ taskSheetId, setMethod }) => {
  const {
    loading,
    formData,
    handleChange,
    handleSubmit,
    setDefaultPriority,
    defaultPriority,
    defaultStatus,
    setDefaultStatus,
  } = useEditTaskSheet(taskSheetId, setMethod);

  const { handleSubmit: useFormSubmit } = useForm<IAddTaskSheet>();

  const personalFields = [
    { label: "Description", name: "description", type: "textbox" },
    { label: "Query", name: "query", type: "textarea" },
    { label: "BackLog", name: "backLog", type: "textarea" },
    // { label: "Due Date", name: "dueDate", type: "date" },
  ] as const;
  return (
    <div className="flex flex-col items-center w-full h-full pr-8 pl-6 ">
      <div className="bg-white shadow-md rounded-lg pt-6 pb-6 w-full ">
        <div className="border-b-2 w-[100%]">
          <h1 className="text-3xl mb-2 text-fontBlack ml-5">Edit TaskSheet</h1>
        </div>
        {loading && <Loader />}
        <form
          onSubmit={useFormSubmit(handleSubmit)}
          className="space-y-6 p-6 h-[75vh] overflow-y-scroll"
        >
          <FormFieldset Ftitle="Personal Details">
            <div className="grid grid-cols-4 gap-6 m-4">
              <CustomDropdown
                label="Priority:"
                options={priority}
                defaultOptionId={defaultPriority}
                setDefaultOptionId={setDefaultPriority}
                displayProperty="name"
                value={defaultPriority}
                style="w-full"
              />
              <CustomDropdown
                label="Status:"
                options={status}
                defaultOptionId={defaultStatus}
                setDefaultOptionId={setDefaultStatus}
                displayProperty="name"
                value={defaultStatus}
                style="w-full"
              />
            </div>
            <div className="grid grid-cols-3 gap-6 m-4">
              {personalFields.map((field) => (
                <Input
                  key={field.name}
                  name={field.name}
                  label={field.label}
                  type={field.type}
                  value={formData[field.name]}
                  onChange={handleChange}
                />
              ))}
            </div>
          </FormFieldset>
          <div className="flex justify-center mt-6 ml-2 gap-3">
            <CancelButton
              className="py-2 px-4 h-[56px] w-[200.5px]"
              onClick={() => setMethod?.()}
              children="Cancel"
              type="button"
            />
            <FormButton
              className="py-2 px-4  h-[56px] w-[200.5px]"
              type="submit"
              children="ADD"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditTaskSheet;
